import Joi from "joi";

export default Joi.object({
	host: Joi.string().required(),
	username: Joi.string().required(),
	password: Joi.string().required()
});
